import React from "react"
import styles from "./styles.module.scss"
import Button from "../Button"
import { modalDotLeft, modalDotRight } from "../../images"

const RulesModal = (props) => {
  const { toggleModal } = props
  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        <div className={styles.modal}>
          <div className={styles.header}>
            <div className={styles.leftDot}>
              <img src={modalDotLeft} alt="dot" />
            </div>
            <div className={styles.text}>活动细则</div>
            <div className={styles.rightDot}>
              <img src={modalDotRight} alt="dot" />
            </div>
          </div>
          <div className={styles.provisions}>
            <p>1、用户首次打开宝箱获得幸运值</p>
            <p>2、当幸运值累计达到100以后将开启宝箱</p>
            <p>3、用户宝箱幸运值累计达到100后将不再获得幸运值</p>
            <p>4、好友协助打开宝箱也能获得幸运值</p>
            <p>5、本次活动宝箱每人仅能打开一次</p>
            <p>
              6、兑换奖励者需已在长城证券开通资金账号，一个资金账号仅可参与一次兑奖
            </p>
          </div>
          <div className={styles.btnWrap}>
            <Button title="我知道了" size="sm" onClick={toggleModal} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default RulesModal
